export default __webpack_public_path__ + "static/media/no-user.bfef5c6c.jpg";